import { Link } from "react-router-dom";
import { CATEGORIES } from "@/mocks/site";
import { articlesByCategory } from "@/mocks/articles";
import { Eyebrow } from "@/components/ui/primitives";

const ICONS: Record<string, string> = {
  bts: "ri-camera-lens-line",
  story: "ri-message-3-line",
  interview: "ri-mic-line",
  diary: "ri-book-open-line",
  special: "ri-magic-line",
  process: "ri-pencil-ruler-line",
};

export default function Categories() {
  return (
    <section className="border-t border-background-200 bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="mb-10 max-w-2xl">
          <Eyebrow text="幕后栏目" en="Columns" />
          <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-4xl">
            从六个视角，拆开一部短片的诞生
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
            每部小电影的正片之外，都藏着一整条看不见的创作链条。沿着六个栏目，一路挖到片场的灯光、台词与每一次取舍。
          </p>
        </div>

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {CATEGORIES.map((c, idx) => (
            <Link
              key={c.id}
              to={`/column?c=${c.id}`}
              className="group flex items-start gap-4 rounded-lg border border-background-200 bg-background-100 p-5 transition hover:border-primary-400/50 hover:bg-background-100"
            >
              <span
                className={
                  "flex h-12 w-12 shrink-0 items-center justify-center rounded-md text-xl " +
                  (idx % 2 === 0 ? "bg-primary-500/15 text-primary-300" : "bg-accent-500/15 text-accent-300")
                }
              >
                <i className={ICONS[c.id] ?? "ri-film-line"} />
              </span>
              <div className="min-w-0">
                <div className="flex items-center gap-2">
                  <h3 className="font-heading text-lg font-semibold text-foreground-950">{c.name}</h3>
                  <span className="rounded-full bg-background-200 px-2 py-0.5 text-xs text-foreground-500">
                    {articlesByCategory(c.id).length} 篇
                  </span>
                </div>
                <p className="font-display mt-0.5 text-xs tracking-[0.15em] text-primary-600 uppercase">{c.en}</p>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{c.tagline}</p>
                <span className="mt-3 inline-flex items-center gap-1 text-xs font-medium text-primary-300 opacity-0 transition group-hover:opacity-100">
                  查看栏目 <i className="ri-arrow-right-line" />
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}